module.exports = "/_next/static/images/400853fa291d1f0c4b568bdab2c9ce82-google-pay.png.webp";